import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

// Inter und JetBrains Mono werden ueber @fontsource lokal aus node_modules gebundled.
// Keine Netzwerkrequests zu fonts.googleapis.com — DSGVO-konform.
// 400/500/600/700/800 deckt regular bis extra-bold ab.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
// Press Start 2P fuer Minecraft-Look Headlines/Logo (Open-Source-Pixelfont,
// selbst-gehostet aus node_modules → DSGVO-konform).
import '@fontsource/press-start-2p/400.css';

import './style.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);

// Bootloader erst entfernen wenn der Router seine erste Navigation
// abgeschlossen hat — sonst wuerde man fuer einen Frame eine leere
// app-div sehen.
router.isReady().then(() => {
  app.mount('#app');
  // Doppelte requestAnimationFrame: einmal damit Vue paintet, dann
  // entfernen wir den Loader. Glatt, kein Flash.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.getElementById('shruby-bootloader')?.remove();
    });
  });
});
